import { createReducer } from 'redux-starter-kit';
import { handleError } from '../../utils/handleError';
import i18next from 'i18next';
import { ReportQRApi } from '../../_helpers/service';
import { ROLES } from '../../_helpers/Constants';

/**
 * Constants
 */

export const reportQRPageModule = 'reportQRPage';
const LOADING_TABLE = `${reportQRPageModule}/LOADING_TABLE`;
const TABLE_DATA = `${reportQRPageModule}/TABLE_DATA`;
const CLEAR_STATE = `${reportQRPageModule}/CLEAR_STATE`;

/**
 * Reducer
 */

const initialState = {
  loadingTable: false,
  tableData: {
    content: [],
    totalElements: 0
  }
};

export default createReducer(initialState, {
  [LOADING_TABLE]: (state, action) => {
    state.loadingTable = action.payload;
  },
  [TABLE_DATA]: (state, action) => {
    const filter = action.filter || {};
    if (filter.pageNumber && filter.pageNumber !== 1) {
      state.tableData.content = [...state.tableData.content, ...action.payload.content];
    } else {
      state.tableData = action.payload;
    }
  },
  [CLEAR_STATE]: () => initialState
});

/**
 * Actions
 */

export const clearState = () => ({ type: CLEAR_STATE });

export const loadData = ({ filter }) => async (dispatch, getState) => {
  try {
    dispatch({ type: LOADING_TABLE, payload: true });
    const userProfile = { ...getState().login.user };
    let isSUO = false;
    if (userProfile.roles) {
      userProfile.roles.forEach((item) => {
        if (item === ROLES.ES_REGION_EMPLOYEES) {
          isSUO = true;
        }
      });
    }
    if (filter.serviceProviderLocation || userProfile.organization_id || isSUO) {
      const {data} = await ReportQRApi.loadData(JSON.stringify(filter));
      dispatch({ type: TABLE_DATA, payload: data.result, filter });
    } else {
      dispatch({ type: TABLE_DATA, payload: {
          content: []
        }, filter });
    }
  } catch (error) {
    handleError(error, i18next.t('reportPage_errorLoadTable'));
  } finally {
    dispatch({ type: LOADING_TABLE, payload: false });
  }
};
